import { TableCell, TableRow, Typography } from "@mui/material";
import React from "react";
import { ProformaEmployeeCostReportSectionRef } from "../../../models/proforma-employee-cost-report/proforma-employee-cost-report-section-ref";
import { SELECTED_PERIOD, SELECTED_PERIOD_DIVIDER } from "../../../utils/constants/employee-cost-report-constants";

interface Props {
  selectedPeriod?: SELECTED_PERIOD;
  section: ProformaEmployeeCostReportSectionRef;
  monthlyView: boolean;
}
const ExportedProformaEmployeeCostReportPriceToTheClientSection = ({ selectedPeriod, section, monthlyView }: Props) => {
  return (
    <>
      <TableRow>
        <TableCell
          style={{
            verticalAlign: "text-top",
            fontWeight: "bold",
          }}
        >
          {section.type?.name}
        </TableCell>

        {selectedPeriod === SELECTED_PERIOD.monthly || monthlyView ? (
          <>
            <TableCell align="center"> Monthly </TableCell>
            <TableCell align="right">
              <Typography>{(section.amount / SELECTED_PERIOD_DIVIDER.monthly).toLocaleCustom() ?? 0}</Typography>
            </TableCell>
          </>
        ) : selectedPeriod === SELECTED_PERIOD.yearly ? (
          <>
            <TableCell align="center"> Yearly </TableCell>
            <TableCell align="right">
              <Typography>{section.amount.toLocaleCustom() ?? 0}</Typography>
            </TableCell>
          </>
        ) : selectedPeriod === SELECTED_PERIOD.daily ? (
          <>
            <TableCell align="center"> Daily </TableCell>
            <TableCell align="right">
              <Typography>{(section.amount / SELECTED_PERIOD_DIVIDER.daily).toLocaleCustom() ?? 0}</Typography>
            </TableCell>
          </>
        ) : selectedPeriod === SELECTED_PERIOD.hourly ? (
          <>
            <TableCell align="center"> Hourly </TableCell>
            <TableCell align="right">
              <Typography>{(section.amount / SELECTED_PERIOD_DIVIDER.hourly).toLocaleCustom() ?? 0}</Typography>
            </TableCell>
          </>
        ) : (
          <>
            <TableCell> </TableCell>
            <TableCell></TableCell>
          </>
        )}
      </TableRow>
    </>
  );
};

export default ExportedProformaEmployeeCostReportPriceToTheClientSection;
